export default __webpack_public_path__ + "static/media/credit-card.ef662706.svg";